import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';
import '../../Components/Product/Product.css';

// Import images
import bag1 from '../../Assets/Images/bag1.webp';
import bag2 from '../../Assets/Images/bag2.webp';
import bag3 from '../../Assets/Images/bag3.webp';
import bag4 from '../../Assets/Images/bag4.webp';
import bag5 from '../../Assets/Images/bag5.webp';
import bag6 from '../../Assets/Images/bag6.webp';
import bag7 from '../../Assets/Images/bag7.webp';
import bag8 from '../../Assets/Images/bag8.webp';

const products = [
  {
    image: bag1,
    title: "Aria Laptop Bag",
    reviews: 103,
    rating: 4,
    price: 3760,
    oldPrice: 8000,
    discount: 53,
  },
  {
    image: bag2,
    title: "Fero",
    reviews: 66,
    rating: 4,
    price: 4390,
    oldPrice: 10000,
    discount: 56,
  },
  {
    image: bag3,
    title: "Eden",
    reviews: 0,
    rating: 5,
    price: 2390,
    oldPrice: 5975,
    discount: 60,
  },
  {
    image: bag4,
    title: "Renn",
    reviews: 0,
    rating: 5,
    price: 2990,
    oldPrice: 8725,
    discount: 65,
  },
  {
    image: bag5,
    title: "Bria",
    reviews: 21,
    rating: 5,
    price: 2388,
    oldPrice: 6000,
    discount: 60,
  },
  {
    image: bag6,
    title: "Sara",
    reviews: 0,
    rating: 5,
    price: 4490,
    oldPrice: 11975,
    discount: 62,
  },
  {
    image: bag7,
    title: "Brio",
    reviews: 2,
    rating: 5,
    price: 4990,
    oldPrice: 12475,
    discount: 60,
  },
  {
    image: bag8,
    title: "Leo",
    reviews: 0,
    rating: 5,
    price: 1790,
    oldPrice: 3800,
    discount: 52,
  },
];

const ProductCard = ({ image, title, reviews, rating, price, oldPrice, discount }) => {
  return (
    <div className="product-card">
      <img src={image} alt={title} className="product-image" />
      <div className="product-details">
        <h2 className="product-title">{title}</h2>
        <div className="product-rating">
          {[...Array(5)].map((_, i) => (
            <FontAwesomeIcon
              key={i}
              icon={faStar}
              color={i < rating ? "gold" : "#ccc"}
            />
          ))}
          <span>{reviews} Reviews</span>
        </div>
        <div className="product-price">
          <span className="current-price">Rs. {price}</span>
          <span className="old-price">Rs. {oldPrice}</span>
          <span className="discount">{discount}% Off</span>
        </div>
        <button className="add-to-cart">Add to Cart</button>
      </div>
    </div>
  );
};

function Product() {
  // Split products into two rows
  const firstRowProducts = products.slice(0, 4);
  const secondRowProducts = products.slice(4, 8);

  return (
    <div className="product-list">
      <h1>Shop Our Favourites</h1>
      <div className="products-container">
        {firstRowProducts.map((product, index) => (
          <ProductCard key={index} {...product} />
        ))}
      </div>
      <div className="products-container">
        {secondRowProducts.map((product, index) => (
          <ProductCard key={index + 4} {...product} />
        ))}
      </div>
    </div>
  );
}

export default Product;
